import type { CSSProperties, ReactNode } from "react";
import { FintheonNumericText } from "../numbers/FintheonNumericText";

interface DigitGroupProps {
  /** The numeric / textual value to render. Each character becomes one <span>. */
  value: string;
  /** Inline style passed through to the wrapping <span>. */
  style?: CSSProperties;
  className?: string;
  /** Optional trailing render slot (e.g. a "%" label that should NOT animate). */
  suffix?: ReactNode;
}

export function DigitGroup({
  value,
  style,
  className,
  suffix,
}: DigitGroupProps) {
  return (
    <span
      className={`t-digit-group${className ? ` ${className}` : ""}`}
      style={style}
    >
      <FintheonNumericText text={value} />
      {suffix}
    </span>
  );
}
